var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundCatalog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 797,
    viewBox: "0 0 354 797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12_463333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -44.9976,
    cy: 476.423,
    r: 319.576,
    transform: "rotate(-90 -44.9976 476.423)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -44.9976,
    cy: 476.423,
    r: 319.576,
    transform: "rotate(-90 -44.9976 476.423)",
    fill: "url(#paint0_linear_12_463333)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -44.9976,
    cy: 476.423,
    r: 319.576,
    transform: "rotate(-90 -44.9976 476.423)",
    fill: "url(#paint1_radial_12_463333)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -44.9976,
    cy: 476.423,
    r: 319.826,
    transform: "rotate(-90 -44.9976 476.423)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_12_463333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -45.0022,
    cy: 319.576,
    r: 319.576,
    transform: "rotate(90 -45.0022 319.576)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -45.0022,
    cy: 319.576,
    r: 319.576,
    transform: "rotate(90 -45.0022 319.576)",
    fill: "url(#paint2_linear_12_463333)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -45.0022,
    cy: 319.576,
    r: 319.576,
    transform: "rotate(90 -45.0022 319.576)",
    fill: "url(#paint3_radial_12_463333)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -45.0022,
    cy: 319.576,
    r: 319.826,
    transform: "rotate(90 -45.0022 319.576)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_12_463333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -123.424,
    cy: 398,
    r: 319.576,
    transform: "rotate(90 -123.424 398)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -123.424,
    cy: 398,
    r: 319.576,
    transform: "rotate(90 -123.424 398)",
    fill: "url(#paint4_linear_12_463333)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -123.424,
    cy: 398,
    r: 319.576,
    transform: "rotate(90 -123.424 398)",
    fill: "url(#paint5_radial_12_463333)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -123.424,
    cy: 398,
    r: 319.826,
    transform: "rotate(90 -123.424 398)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_12_463333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.4262,
    cy: 398,
    r: 319.576,
    transform: "rotate(-90 33.4262 398)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.4262,
    cy: 398,
    r: 319.576,
    transform: "rotate(-90 33.4262 398)",
    fill: "url(#paint6_radial_12_463333)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.4262,
    cy: 398,
    r: 319.576,
    transform: "rotate(-90 33.4262 398)",
    fill: "url(#paint7_linear_12_463333)",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33.4262,
    cy: 398,
    r: 319.826,
    transform: "rotate(-90 33.4262 398)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12_463333",
    x: -365.074,
    y: 156.347,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_12_463333"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12_463333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_12_463333",
    x: -365.078,
    y: -0.5,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_12_463333"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12_463333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_12_463333",
    x: -443.5,
    y: 77.9236,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_12_463333"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12_463333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_12_463333",
    x: -286.65,
    y: 77.9235,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_12_463333"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12_463333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_463333",
    x1: 546.413,
    y1: 223.97,
    x2: -63.2883,
    y2: 338.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12_463333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.343 477.677) rotate(-180) scale(626.507)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842199,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_463333",
    x1: -830.378,
    y1: 426.293,
    x2: -126.088,
    y2: 700.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.518602,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12_463333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-45.0021 319.576) rotate(179.827) scale(414.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_463333",
    x1: 467.987,
    y1: 145.547,
    x2: -141.715,
    y2: 260.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12_463333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-284.129 430.061) rotate(21.7389) scale(640.683 727.286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224735,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37505,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66121,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783675,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12_463333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.721 319.574) rotate(137.992) scale(510.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_463333",
    x1: 624.837,
    y1: 145.546,
    x2: 15.1356,
    y2: 260.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCatalog);
export default __webpack_public_path__ + "static/media/background-catalog.4953002d636eec85b0f017c9ee283024.svg";
export { ForwardRef as ReactComponent };